import { createEl } from '../lib/dom';
import { SITE } from '../site/site-config';
import { createStoresBlock } from '../ui/store-badges';

const TERMS_HREF = '/terms';

export function renderFooter(target: HTMLElement): void {
  const footer = createEl(
    'footer',
    {
      className: 'sv-footer',
      role: 'contentinfo',
    },
    [
      createEl('div', { className: 'sv-inner sv-footer__inner' }, [
        createEl('div', { className: 'sv-footer__brand' }, [
          createEl('img', {
            className: 'sv-footer__logo',
            src: '/favicon.png',
            alt: '',
            width: '44',
            height: '44',
          }),
          createEl('span', { className: 'sv-footer__name' }, [SITE.name]),
        ]),
        createStoresBlock({ variant: 'footer', showHeadline: false }),
        createEl('nav', { className: 'sv-footer__links', 'aria-label': 'Legal' }, [
          createEl('a', { href: TERMS_HREF }, ['Términos y condiciones -']),
          createEl('a', { href: `${TERMS_HREF}#politica` }, [' Política de datos personales']),
        ]),
        createEl('p', { className: 'sv-footer__notice' }, [SITE.footer.notice]),
        createEl('p', { className: 'sv-footer__copy' }, [
          `© ${SITE.footer.copyYear} ${SITE.name}. Todos los derechos reservados.`,
        ]),
      ]),
    ]
  );
  target.appendChild(footer);
}
